module.exports = __webpack_public_path__ + "img/intro_mo_img04.87bc5d86.png";